import { Services } from '../services';
import type { CarSearchFilters, CarSearchInitialData, RentalType } from '../types';

export const getLocationResponse = async (
  locationCode: CarSearchInitialData['location'][RentalType],
  filterSearchBy: CarSearchFilters,
) => {
  const searchResponse = await Services.core.getSearch(locationCode.toString(), filterSearchBy);

  if (searchResponse) {
    // const selectedResponse = searchResponse.find((response) => response.code.toString() === locationCode);
    const selectedResponse = searchResponse[0];

    if (selectedResponse) {
      return selectedResponse;
    }
  }

  return null;
};
